import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Icon } from '@grandvisionhq/icons';
import FormControlFieldWrapper from '../FormControl/FormControlWrapper.js';

const PhoneNumberInput = (_param)=>{
    var { formControlWrapperProps , id , required , className , inputClasses , value , PhoneNumberInputComponent  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "formControlWrapperProps",
        "id",
        "required",
        "className",
        "inputClasses",
        "value",
        "PhoneNumberInputComponent"
    ]);
    return /*#__PURE__*/ React.createElement(FormControlFieldWrapper, swcHelpers.extends({}, formControlWrapperProps, {
        id: id,
        required: required
    }), /*#__PURE__*/ React.createElement(PhoneNumberInputComponent, swcHelpers.extends({}, swcHelpers.objectSpread({
        id,
        className: inputClasses,
        countrySelectProps: {
            arrowComponent: ()=>/*#__PURE__*/ React.createElement(Icon, {
                    className: "PhoneInputCountry--icon",
                    name: "chevron-down"
                })
        },
        focusInputOnCountrySelection: false
    }, rest, {
        /* pass undefined instead of empty string, because
          empty string will also reset the selected country */ value: value || undefined,
        type: 'tel'
    }))));
};

export { PhoneNumberInput as default };
//# sourceMappingURL=PhoneNumberInput.js.map
